import React, { useState, useRef } from 'react';

import './AiSolution.css';
import downloadiconimg from '../../assest/Download Icon.png'
import uploadiconimg from '../../assest/Upload Icon.png'
import starticonimg from '../../assest/start Icon.png'
import topimg from '../../assest/Top Left.png'
import rightshapeimg from '../../assest/Top Right.png'

const AiSolution = () => {
  const [showPopup,setShowPopup]= useState(false)
  const [modal,setshowmodal] = useState(false)
  const [studentData, setStudentData] = useState([]);
  const fileInputRef = useRef(null);
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      //const response = await fetch('http://localhost:8004/api/upload', { //Uncomment this line if you have a backend server running
      const response = await fetch("https://cz-engine.onrender.com/api/upload", {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      if (response.ok) {
        // alert(result.message);
     setShowPopup(true)



        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }





      } else {
        alert(' Upload failed: ' + result.message);
      }
    } catch (err) {
      console.error(err);
      setshowmodal(true)
    }
  };

  const handleDownloadExcel = () => {
    const fileUrl = 'http://localhost:3000/data format.xlsx';
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', 'student-data-format.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className='Ai-container'>
          <img id="leftshapeimg" src={topimg} alt='shape img'/>
          <img className='rightshapeimg' src={rightshapeimg} alt='shape'/>
        <div className='Ai-wrapper'>
          <h2 className='main-heading'>AI student Analyzer</h2>
          <p className='main-para'>Empower Every Student’s Growth with AI Insights</p>


          <h2 className='first-heading'>Our AI-driven platform transforms everyday data into meaningful insights, revealing both strengths and pain points. This empowers teachers to personalize their approach and helps parents support their children more effectively.</h2>
          <h2 className='second-heading'>  Whether you're tracking academic progress, identifying learning gaps, or crafting tailored nurturing plans, our tool provides the clarity, insight, and guidance needed to support every student’s unique growth journey. </h2>




          <h2 className='tag-heading'> What You Can Do Here:
          </h2>

          <div className="step-container">
            <div className="step-box">
              <h3>STEP - 1  </h3>
              <button onClick={handleDownloadExcel}><img src={downloadiconimg}/>Download Template</button>
              <p>Start by downloading our ready-to-use template. It’s structured to make data entry easy. </p>
              <p>Just fill in student details like academic scores, attendance, and activities.</p>
            </div>
           <div className="step-box2">
  <h3>Step - 2</h3>

  <input
    type="file"
    accept=".xlsx, .xls"
    onChange={handleFileUpload}
    ref={fileInputRef}
    style={{ display: "none" }}
  />


  <button onClick={() => fileInputRef.current.click()}>
    <img src={uploadiconimg} alt='upload img'/>
    Upload for AI Analysis
  </button>

  <p>
    Once you’ve filled in the student information, simply upload it here.
    <br /> Our AI system instantly gets to work.
  </p>
</div>


            <div className="step-box3" >
              <h3>Step - 3 </h3>
              <button> <img src={starticonimg} alt='start-icon'/>Get My Reports</button>
              <p>You'll receive personalized reports for each student. These highlight:</p>
              <ul>
                <li>Strengths and academic inclinations</li>
                <li>Areas needing improvement</li>
                <li>Actionable suggestions for growth</li>
              </ul>
            </div>

          </div>






        </div>
         {showPopup && (
<div className="submit-popup-overlay">
<div className="submit-popup-box">
  <h2>File uploaded successfully</h2>
  <p>Our team will get back to you soon.</p>
  <button className='submit-popup-button' onClick={() => setShowPopup(false)}>Close</button>
</div>
</div>
)}
 {modal && (
<div className="submit-popup-overlay">
<div className="submit-popup-box">
  <h2>Only .csv/.xlsx </h2>
  <p>Files are allowed. Please upload a valid CSV/XLSX file.</p>
  <button className='submit-popup-button' onClick={() => setshowmodal(false)}>Close</button>
</div>
</div>
)}
      </div>
      <h2 className="experience-heading">Experience a smarter way to understand students</h2>

      <div className='respect-section'>
        <div className="respect-wrapper">
          <div className="respect-left">
            <h2>Who Is This For &nbsp;?
            </h2>
            <p>This platform is built for :</p>
            <p><span>Teachers</span> – to personalize teaching and track student progress
            </p>
            <p><span>School Leaders</span> – to drive data-informed decisions.</p>
            <p><span>Parents</span> – to better support their child’s learning journey</p>
            <p><span>Students</span> – to understand their strengths, improve focus areas, and take charge of their own growth</p>

          </div>
          <div className='vl'></div>
          <div className='respect-right'>
            <h2>We Respect Your Privacy
            </h2>
            <p>We take your privacy seriously:
            </p>
            <ul>

              <li>  All uploads are secure</li>
              <li>No long-term data storage</li>
              <li>100% school-safe processing</li>
            </ul>
          </div>
        </div>
      </div>

<div className='ready-container'>
  <div className='ready-wrapper'>
      <h2>Using AI to support student success has never been easier.
      </h2>
      <p>Ready to Get Started?</p>
      </div>
      </div>

    </>
  );
};

export default AiSolution;
